module.exports = __webpack_public_path__ + "d27ebf5f23683855c7b2e1b896a81528.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-bg01-iphone.png
// module id = 838
// module chunks = 3